__turbopack_context__.v({
  "dotFlashing": "DYQqXq_dotFlashing",
});
